var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"gl-pl-0"},_vm._l((_vm.images),function(listItem,index){return _c('li',{key:index,staticClass:"gl-list-none"},[_c('image-list-row',{attrs:{"item":listItem,"metadata-loading":_vm.metadataLoading,"expiration-policy":_vm.expirationPolicy},on:{"delete":function($event){return _vm.$emit('delete', $event)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }